import { Component, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { VueParcoursComponent } from './vue-parcours/vue-parcours.component';
import { VueUtilisateursComponent } from './vue-utilisateurs/vue-utilisateurs.component';
import { VueContenusComponent } from './vue-contenus/vue-contenus.component';

@Component({
    selector: 'app-rapports-parcours-formation',
    imports: [
    TranslateModule,
    MatTabsModule,
    MatIconModule,
    VueParcoursComponent,
    VueUtilisateursComponent,
    VueContenusComponent
],
    templateUrl: './rapports-parcours-formation.component.html',
    styleUrl: './rapports-parcours-formation.component.scss'
})
export class RapportsParcoursFormationComponent implements OnInit {
  activeTabIndex = 0;
  filtreParcoursFormationId?: number;
  filtreUtilisateurId?: number;

  ngOnInit(): void {}

  naviguerVersUtilisateurs(parcoursFormationId: number): void {
    this.filtreParcoursFormationId = parcoursFormationId;
    this.filtreUtilisateurId = undefined;
    this.activeTabIndex = 1;
  }

  naviguerVersContenus(parcoursFormationId: number, utilisateurId: number): void {
    this.filtreParcoursFormationId = parcoursFormationId;
    this.filtreUtilisateurId = utilisateurId;
    this.activeTabIndex = 2;
  }

  reinitialiserFiltresNavigation(): void {
    this.filtreParcoursFormationId = undefined;
    this.filtreUtilisateurId = undefined;
  }
}
